import { TreatmentProvider } from "./models/TreatmentProviders.models";

export class TreatmentProviderUtils {
  static getAddressString(data: TreatmentProvider) {
    let value = "";
    if (data.address) {
      value += data.address;
    }
    if (data.city) {
      value += " ";
      value += data.city;
    }
    if (data.state) {
      if (data.city) value += ", ";
      else value += " ";
      value += data.state;
    }
    if (data.zip) {
      value += " ";
      value += data.zip;
    }
    return value;
  }

  // static filterProviders(providers: ITreatmentProvider[], selectedDemographics: Demographic[], selectedServices: ServiceOffered[]): ITreatmentProvider[] {
  //   let filteredList = providers;
  //
  //   // filter list by demographics
  //   if (selectedDemographics?.length > 0) {
  //     const keywords = flatMap(selectedDemographics, (x: Demographic) => x.keywords);
  //     filteredList = filteredList.filter((p: ITreatmentProvider) => this.CheckServicesOfferedForKeywords(p.servicesOffered, keywords));
  //   }
  //
  //   // filter list by services
  //   if (selectedServices?.length > 0) {
  //     const keywords = flatMap(selectedServices, (x: ServiceOffered) => x.keywords);
  //     filteredList = filteredList.filter(p => this.CheckServicesOfferedForKeywords(p.servicesOffered, keywords));
  //   }
  //
  //   return filteredList;
  // }
  //
  //
  // static CheckServicesOfferedForKeywords(ServicesOffered: string, keywords: string[] | any) {
  //   if (keywords === null || keywords === undefined || keywords.length === 0) return false;
  //   if (ServicesOffered === '' || ServicesOffered === undefined || ServicesOffered === null) return false;
  //   let services = words(ServicesOffered);
  //
  //   services = services.map(toLower)
  //   console.log("services: ", services);
  //   console.log("keywords: ", keywords);
  //   let result = intersection(services, keywords);
  //   console.log("intersection: ", result);
  //   let keep = (result.length > 0)
  //   console.log("keep: ", keep);
  //   return keep;
  // }
}
